import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isTimerPaused: false,
  error: false,
  confirm: {
    cancelText: undefined,
    children: undefined,
    confirmText: undefined,
    message: undefined,
    open: false,
    picture: null,
    title: 'Confirmation',
    variant: 'warning',
    handleCancel: undefined,
    handleConfirm: undefined,
    handleClose: undefined
  },
  isModalOpen: false
};

const slice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    // LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      console.error(state.error);
    },

    openConfirm(state, action) {
      state.confirm = {
        ...initialState.confirm,
        ...action.payload,
        open: true
      };
    },

    setIsModalOpen(state, action) {
      state.isModalOpen = action.payload;
    },

    setPauseTimer(state, action) {
      state.isTimerPaused = action.payload;
    },

    closeConfirm(state) {
      state.confirm = initialState.confirm;
    },

    onLogout() {}
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { openConfirm, closeConfirm, setIsModalOpen, onLogout, setPauseTimer } = slice.actions;
